const statusAdminSearchAllProvider = {
    temporary: '1,2,4',
    official: '3,5'
}

export { statusAdminSearchAllProvider }
